import React from 'react'
import { css } from '@emotion/react'

import ArrowDownIcon from '../../icons/ArrowDownIcon'
import Colors from '../../theme/Colors'

export default React.forwardRef<
  HTMLButtonElement,
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
>(SelectorButton)

function SelectorButton(
  {
    children,
    ...props
  }: React.DetailedHTMLProps<React.HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  ref:
    | ((instance: HTMLButtonElement | null) => void)
    | React.MutableRefObject<HTMLButtonElement | null>
    | null,
) {
  return (
    <button
      {...props}
      ref={ref}
      css={css`
        min-height: 42px;
        border-radius: 2px;
        border: 1px solid ${Colors.Gray100};
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: ${Colors.White};
      `}
    >
      {children}

      <div
        css={css`
          position: relative;
          top: 1px;
        `}
      >
        <ArrowDownIcon />
      </div>
    </button>
  )
}
